import script from "./OurGuest.vue?vue&type=script&setup=true&lang=js"
export * from "./OurGuest.vue?vue&type=script&setup=true&lang=js"

import "./OurGuest.vue?vue&type=style&index=0&id=31ec84b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ec84b6"]])

export default __exports__